import React from "react";
import UseContext from "../../hooks/useContext";
import useModal from "../modal/useModal";
import { SettingRow } from "../settings/SettingRow";

function SundayHoursBlock({ isSundayHours, isWaiting, onCommitSundayHours }) {
  const { setModalData } = UseContext();
  const { toggle } = useModal();

  const openModal = () => {
    setModalData({
      block: "sunday",
      isSundayHours,
      isWaiting,
      commitSundayHours: onCommitSundayHours,
      modalSessionKey: Date.now(),
    });
    toggle("settings_edit_block");
  };

  const description = isWaiting ? (
    <div className="h-4 max-w-lg animate-pulse rounded bg-gray-200" />
  ) : (
    <>
      Une ligne avec le code{" "}
      <strong className="font-semibold text-gray-800">1205</strong> sera ajoutée
      avec le total des heures travaillées pour chaque dimanche.
    </>
  );

  return (
    <SettingRow
      title="Majoration des heures du dimanche dans le fichier Peopulse"
      description={description}
      onEdit={openModal}
    />
  );
}

export default SundayHoursBlock;
